// extracted by mini-css-extract-plugin
module.exports = {"lightTheme":"App_lightTheme__1UkCs","darkTheme":"App_darkTheme__244Wy"};